import { render } from "./FrenteCaixaModal.vue?vue&type=template&id=babaf050&scoped=true&ts=true"
import script from "./FrenteCaixaModal.vue?vue&type=script&lang=ts"
export * from "./FrenteCaixaModal.vue?vue&type=script&lang=ts"

import "./FrenteCaixaModal.vue?vue&type=style&index=0&id=babaf050&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-babaf050"]])

export default __exports__